import { SkeletonLoader } from '@design/components/skeleton-loader/SkeletonLoader';
import { useEarningsInsightsFilter } from '@terminal/react-query-hooks/insights/useEarningsInsightsFilter';
import { parseEarningsInsights } from '@terminal/react-query-hooks/insights/useEarningsInsightsFilter.utils';
import { POSTHOG_TRACKING_SOURCES } from '@terminal/services/tracking/posthog/constants';
import { useSubscription } from '@terminal/stores/use-subscription/useSubscription';
import { EarningsInsightPill } from '@terminal/widgets/earnings-insight-drawer/earnings-insight-widget/components/earnings-insight-pill/EarningsInsightPill';

interface EarningInsightsCellProps {
  earningsId: string;
  entityTag?: string;
}

export const EarningInsightsCell = ({
  earningsId,
  entityTag,
}: EarningInsightsCellProps) => {
  const isBasicOrLightUser = useSubscription(state =>
    state.isBasicOrLightUser()
  );

  const { data: earningsInsightsData = [], isFetching } =
    useEarningsInsightsFilter({
      body: { earnings_ids: [earningsId] },
      isEnabled: !isBasicOrLightUser,
    });
  const earningsInsight = parseEarningsInsights(earningsInsightsData);

  const hasData = !!earningsInsight && !isBasicOrLightUser && !!entityTag;

  if (isFetching) {
    return (
      <div>
        <SkeletonLoader
          areas={[
            {
              styles: {
                width: '180px',
                height: '25px',
                borderRadius: '8px',
              },
            },
          ]}
        />
      </div>
    );
  }

  return hasData ? (
    <EarningsInsightPill
      entityTag={entityTag}
      earningsInsight={earningsInsight}
      isPreview={earningsInsight?.type === 'preview'}
      source={POSTHOG_TRACKING_SOURCES.EVENTS}
    />
  ) : null;
};
